import { render } from "./RegistrationTicketVerify.vue?vue&type=template&id=04c5503e"
import script from "./RegistrationTicketVerify.vue?vue&type=script&lang=js"
export * from "./RegistrationTicketVerify.vue?vue&type=script&lang=js"

import "./RegistrationTicketVerify.vue?vue&type=style&index=0&id=04c5503e&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__